import React from 'react'
import { Box } from '@mantine/core'

/* This is for health check, and testing */
const SuccessPage = () => {
  return <Box>Success</Box>
}

export default SuccessPage
